import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CreateQRCodeParams } from 'src/app/shared/models/iTemplate/create-qr-code';
import { OCRImageDTO } from 'src/app/shared/models/iTemplate/ocr-image';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DocumentEditorService {
  public baseUrlDocumentEditor: string;

  constructor(private http: HttpClient) {
    const config = environment;
    this.baseUrlDocumentEditor = config.baseUrlDocumentEditor;
  }

  /*
   * @param document document to be sent in OCR
   * @param langage : Tesseract OCR language: fra (default), eng   => Default value : fra
   */
  public postOCR(document: Blob, langage?: string): Observable<OCRImageDTO> {
    const formData: FormData = new FormData();
    formData.append('image', document, 'image.png');
    if (langage) {
      return this.http.post<OCRImageDTO>(`${this.baseUrlDocumentEditor}/DocumentProcessor/OcrImage?langage=${langage}`, formData);
    }
    return this.http.post<OCRImageDTO>(`${this.baseUrlDocumentEditor}/DocumentProcessor/OcrImage`, formData);
  }

  public postCreateQRCode(data: CreateQRCodeParams): Observable<Blob> {
    return this.http.post(`${this.baseUrlDocumentEditor}/DocumentProcessor/CreateQRCode`, data, {
      responseType: 'blob',
    });
  }
}
